export default {
    // When the bound element is inserted into the DOM...
    inserted(el) {
        // Focus the element
        el.focus();
    },
};



// WEBPACK FOOTER //
// ./src/directives/focus.js